import _defineProperty from "/workdir/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { Box } from '@hub/box';
import { IconButton } from '@hub/button';
import { ChevronLeftSmallIcon, ChevronRightSmallIcon } from '@hub/icon';
import { Imposter } from '@hub/imposter';
import { Reel } from '@hub/reel';
import React from 'react'; // useMobileBreakpoint looks unavoidable here due to the props composition
// and complex logic
// eslint-disable-next-line no-restricted-syntax

import useMobileBreakpoint from '../../helpers/use-mobile-breakpoint';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";

const LinkReel = props => {
  const isMobileBreakpoint = useMobileBreakpoint();
  const isMobile = props.isMobile === undefined ? isMobileBreakpoint : props.isMobile;
  return /*#__PURE__*/_jsx(Reel, _objectSpread(_objectSpread({}, props), {}, {
    visibleFrames: 0,
    sx: _objectSpread(_objectSpread({}, props.sx), {}, {
      marginLeft: ['-spacing-lg', '-spacing-lg', 0],
      marginRight: ['-spacing-lg', '-spacing-lg', 0],
      marginBottom: 'spacing-lg',
      scrollbarWidth: 'none'
    }, isMobile && {
      width: 'auto',
      paddingRight: 'spacing-lg',
      paddingLeft: 'spacing-lg',
      WebkitMaskImage: "linear-gradient(\n                to right,\n                rgba(0,0,0,0) 2px, rgba(0,0,0,1) 24px,\n                rgba(0,0,0,1) calc(100% - 24px), rgba(0,0,0,0) calc(100% - 2px)\n              )"
    }),
    renderControls: _ref => {
      let {
        scrollPosition,
        children,
        prevComponentProps,
        nextComponentProps
      } = _ref;
      return /*#__PURE__*/_jsx(Imposter, {
        impose: !isMobile && scrollPosition !== 'full' ? /*#__PURE__*/_jsx(Box, {
          sx: {
            backgroundColor: 'white',
            height: '100%',
            paddingLeft: 'spacing-sm',
            visibility: scrollPosition === 'end' ? 'hidden' : 'visible'
          },
          "data-id": "link-reel_index_LinkReel_Box",
          children: /*#__PURE__*/_jsx(IconButton, _objectSpread(_objectSpread({}, nextComponentProps), {}, {
            icon: /*#__PURE__*/_jsx(ChevronRightSmallIcon, {
              "data-id": "link-reel_index_LinkReel_ChevronRightSmallIcon"
            }),
            variant: "solid",
            colorScheme: "white",
            size: "sm",
            "aria-label": "Scroll to next",
            "aria-hidden": "true",
            sx: {
              aspectRatio: '1',
              minWidth: 'unset',
              borderRadius: '50%',
              display: ['none', 'inherit'],
              position: 'relative',
              top: 'calc(50% - 18px)'
            },
            "data-id": "link-reel_index_LinkReel_Box_IconButton"
          }))
        }) : /*#__PURE__*/_jsx(_Fragment, {}),
        position: "right",
        "data-id": "link-reel_index_LinkReel_Imposter",
        children: /*#__PURE__*/_jsx(Imposter, {
          impose: !isMobile && scrollPosition !== 'full' ? /*#__PURE__*/_jsx(Box, {
            sx: {
              backgroundColor: 'white',
              height: '100%',
              paddingRight: 'spacing-sm',
              visibility: scrollPosition === 'start' ? 'hidden' : 'visible'
            },
            "data-id": "link-reel_index_LinkReel_Box",
            children: /*#__PURE__*/_jsx(IconButton, _objectSpread(_objectSpread({}, prevComponentProps), {}, {
              icon: /*#__PURE__*/_jsx(ChevronLeftSmallIcon, {
                "data-id": "link-reel_index_LinkReel_ChevronLeftSmallIcon"
              }),
              variant: "solid",
              colorScheme: "white",
              size: "sm",
              "aria-label": "Scroll to previous",
              "aria-hidden": "true",
              sx: {
                aspectRatio: '1',
                minWidth: 'unset',
                borderRadius: '50%',
                display: ['none', 'inherit'],
                position: 'relative',
                top: 'calc(50% - 18px)'
              },
              "data-id": "link-reel_index_LinkReel_Box_IconButton"
            }))
          }) : /*#__PURE__*/_jsx(_Fragment, {}),
          position: "left",
          "data-id": "link-reel_index_LinkReel_Imposter_Imposter",
          children: children
        })
      });
    },
    "data-id": "link-reel_index_LinkReel_Reel",
    children: props.children
  }));
};

export default LinkReel;